import { Tooltip as AntTooltip, type GetRef, type GetProps } from 'antd';
import { forwardRef } from 'react';
import { useTheme } from 'styled-components';

export type TooltipRef = GetRef<typeof AntTooltip>;
export type TooltipProps = GetProps<typeof AntTooltip>;

export const Tooltip = forwardRef<TooltipRef, TooltipProps>(({ children, ...restProps }, ref) => {
  const theme = useTheme();

  return (
    <AntTooltip ref={ref} color={theme.color.grey.white} {...restProps}>
      {children}
    </AntTooltip>
  );
});
